// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*--------------------------------------------------------------
# Results Collapse Section
--------------------------------------------------------------*/
.NHDB7139cbMqf04GQoUs {
  margin: 2px 0;
}
.NHDB7139cbMqf04GQoUs .card {
  background-color: var(--surface-color);
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.0627);
  border-radius: 15px;
  border: 0;
}
.NHDB7139cbMqf04GQoUs .card .card-body {
  padding: 0;
}
.NHDB7139cbMqf04GQoUs .card .card-body .QXwQI7mwcty7XCJrxRtc {
  width: 95%;
}
.NHDB7139cbMqf04GQoUs .card .card-body .QXwQI7mwcty7XCJrxRtc .NKivG21Efn5Gl2JO88wo {
  transition: height 0.35s ease;
}
.NHDB7139cbMqf04GQoUs .card .card-body .QXwQI7mwcty7XCJrxRtc .NKivG21Efn5Gl2JO88wo .gDgJkq_46q5sJ0kSVrdW {
  color: #0C3058;
  line-height: 24px;
  font-size: 16px;
  font-weight: 300;
}
.NHDB7139cbMqf04GQoUs .card .card-body .QXwQI7mwcty7XCJrxRtc .NKivG21Efn5Gl2JO88wo .gDgJkq_46q5sJ0kSVrdW img {
  max-width: 100%;
  height: auto;
}
.NHDB7139cbMqf04GQoUs .card .card-body .QXwQI7mwcty7XCJrxRtc .NKivG21Efn5Gl2JO88wo .LyyBsSJAqafj8Cg8C2_v {
  display: -webkit-box;
  -webkit-line-clamp: 3; /* Limit to 3 lines */
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: all 0.3s ease;
  position: relative;
  line-height: 1.5em;
  max-height: 4.5em;
}
.NHDB7139cbMqf04GQoUs .card .card-body .QXwQI7mwcty7XCJrxRtc .NKivG21Efn5Gl2JO88wo .PU2p8D14G3lgQWXrHhak {
  padding: 4px 0 0 0;
  cursor: pointer;
  color: #0068F5;
}
.NHDB7139cbMqf04GQoUs .card .card-body .QXwQI7mwcty7XCJrxRtc .NKivG21Efn5Gl2JO88wo div {
  margin: 0;
}
.NHDB7139cbMqf04GQoUs .card .N7KLsHljLdXNCDe5MgMc {
  display: flex;
  justify-content: space-between;
}
.NHDB7139cbMqf04GQoUs .card .N7KLsHljLdXNCDe5MgMc button {
  height: 24px;
  width: 24px;
}
.NHDB7139cbMqf04GQoUs .card .N7KLsHljLdXNCDe5MgMc h2 {
  margin: 0;
  color: #0C3058;
}
.NHDB7139cbMqf04GQoUs .card .N7KLsHljLdXNCDe5MgMc svg {
  fill: #0C3058;
}
.NHDB7139cbMqf04GQoUs .card .card-title {
  width: 95%;
  font-size: 20px;
  line-height: 24px;
  font-weight: 500;
  color: #0C3058;
  padding: 0;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.NHDB7139cbMqf04GQoUs .card .RFiG3euW7aU7RecxDyx7 {
  margin-top: 10px;
  display: flex;
}
.NHDB7139cbMqf04GQoUs .card .RFiG3euW7aU7RecxDyx7 span {
  display: inline-block;
  color: #000000;
  font-size: 16px;
  margin-left: 10px;
  width: 60px;
}
.NHDB7139cbMqf04GQoUs .card .RFiG3euW7aU7RecxDyx7 ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.NHDB7139cbMqf04GQoUs .card .RFiG3euW7aU7RecxDyx7 ul a, .NHDB7139cbMqf04GQoUs .card .RFiG3euW7aU7RecxDyx7 ul a:hover {
  font-weight: 600 !important;
}
.NHDB7139cbMqf04GQoUs .card .wL4qPyu95KCXPhN_jubU {
  margin-top: 10px;
}
.NHDB7139cbMqf04GQoUs .card .wL4qPyu95KCXPhN_jubU span {
  display: inline-block;
  color: #000000;
  font-size: 16px;
  margin-left: 10px;
  width: 60px;
}
.NHDB7139cbMqf04GQoUs .card .wL4qPyu95KCXPhN_jubU ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: inline;
}
.NHDB7139cbMqf04GQoUs .card .wL4qPyu95KCXPhN_jubU ul li {
  background-color: #EBF3FF;
  color: #000000;
  border-radius: 50px;
  font-size: 14px;
  padding: 5px 15px;
  margin: 0 0 0 8px;
  display: inline-block;
  transition: 0.3s;
}
.NHDB7139cbMqf04GQoUs .card .wL4qPyu95KCXPhN_jubU ul li span {
  padding-left: 5px;
  color: color-mix(in srgb, var(--default-color), transparent 60%);
  font-size: 14px;
}
.NHDB7139cbMqf04GQoUs .card ._1o1FB3AeSfBrXFAcMVeb {
  margin-top: 10px;
}
.NHDB7139cbMqf04GQoUs .card ._1o1FB3AeSfBrXFAcMVeb span {
  display: inline-block;
  color: #000000;
  font-size: 16px;
  margin-left: 10px;
  width: 60px;
}
.NHDB7139cbMqf04GQoUs .card ._1o1FB3AeSfBrXFAcMVeb ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: inline;
}
.NHDB7139cbMqf04GQoUs .card ._1o1FB3AeSfBrXFAcMVeb ul li {
  background-color: #FFECC2;
  color: #000000;
  border-radius: 50px;
  font-size: 14px;
  padding: 5px 15px;
  margin: 0 0 0 8px;
  display: inline-block;
  transition: 0.3s;
}
.NHDB7139cbMqf04GQoUs .card ._1o1FB3AeSfBrXFAcMVeb ul li span {
  padding-left: 5px;
  color: color-mix(in srgb, var(--default-color), transparent 60%);
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./GeneralComponents/SearchResults/searchResults/resultsCollapse/ResultsCollapse.module.scss"],"names":[],"mappings":"AAAA;;+DAAA;AAGA;EACI,aAAA;AACJ;AACI;EACI,sCAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,mBAAA;EACA,SAAA;AACR;AACQ;EACI,UAAA;AACZ;AACY;EACI,UAAA;AAChB;AACgB;EACI,6BAAA;AACpB;AACoB;EACI,cAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AACxB;AACwB;EACI,eAAA;EACA,YAAA;AAC5B;AAGoB;EACI,oBAAA;EACA,qBAAA,EAAA,qBAAA;EACA,aAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AADxB;AAIoB;EACI,kBAAA;EACA,eAAA;EACA,cAAA;AAFxB;AAKoB;EACI,SAAA;AAHxB;AASQ;EACI,aAAA;EACA,8BAAA;AAPZ;AASY;EACI,YAAA;EACA,WAAA;AAPhB;AAUY;EACI,SAAA;EACA,cAAA;AARhB;AAWY;EACI,aAAA;AAThB;AAaQ;EACI,UAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,4BAAA;AAXZ;AAcQ;EACI,gBAAA;EACA,aAAA;AAZZ;AAcY;EACI,qBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;AAZhB;AAeY;EACI,gBAAA;EACA,SAAA;EACA,UAAA;AAbhB;AAegB;EACI,2BAAA;AAbpB;AAkBQ;EACI,gBAAA;AAhBZ;AAkBY;EACI,qBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;AAhBhB;AAmBY;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;AAjBhB;AAmBgB;EACI,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;AAjBpB;AAmBoB;EACI,iBAAA;EACA,gEAAA;EACA,eAAA;AAjBxB;AAuBQ;EACI,gBAAA;AArBZ;AAuBY;EACI,qBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;AArBhB;AAwBY;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;AAtBhB;AAwBgB;EACI,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;AAtBpB;AAwBoB;EACI,iBAAA;EACA,gEAAA;EACA,eAAA;AAtBxB","sourcesContent":["/*--------------------------------------------------------------\r\n# Results Collapse Section\r\n--------------------------------------------------------------*/\r\n.results-collapse {\r\n    margin: 2px 0;\r\n\r\n    :global(.card) {\r\n        background-color: var(--surface-color);\r\n        padding: 20px;\r\n        height: 100%; // Ensure the article takes the full height of its parent\r\n        display: flex;\r\n        flex-direction: column;\r\n        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.0627);\r\n        border-radius: 15px;\r\n        border: 0;\r\n\r\n        :global(.card-body) {\r\n            padding: 0;\r\n\r\n            .card-container {\r\n                width: 95%;\r\n\r\n                .description-container {\r\n                    transition: height 0.35s ease;\r\n\r\n                    .description {\r\n                        color: #0C3058;\r\n                        line-height: 24px;\r\n                        font-size: 16px;\r\n                        font-weight: 300;\r\n\r\n                        img {\r\n                            max-width: 100%;\r\n                            height: auto;\r\n                        }\r\n                    }\r\n\r\n                    .text-clamp-3 {\r\n                        display: -webkit-box;\r\n                        -webkit-line-clamp: 3; /* Limit to 3 lines */\r\n                        line-clamp: 3;\r\n                        -webkit-box-orient: vertical;\r\n                        overflow: hidden;\r\n                        text-overflow: ellipsis;\r\n                        transition: all 0.3s ease;\r\n                        position: relative;\r\n                        line-height: 1.5em;\r\n                        max-height: calc(1.5em * 3);\r\n                    }\r\n\r\n                    .read-more {\r\n                        padding: 4px 0 0 0;\r\n                        cursor: pointer;\r\n                        color: #0068F5;\r\n                    }\r\n\r\n                    div {\r\n                        margin: 0;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        .card-header {\r\n            display: flex;\r\n            justify-content: space-between;\r\n\r\n            button {\r\n                height: 24px;\r\n                width: 24px;\r\n            }\r\n\r\n            h2 {\r\n                margin: 0;\r\n                color: #0C3058;\r\n            }\r\n\r\n            svg {\r\n                fill: #0C3058;\r\n            }\r\n        }\r\n\r\n        :global(.card-title) {\r\n            width: 95%;\r\n            font-size: 20px;\r\n            line-height: 24px;\r\n            font-weight: 500;\r\n            color: #0C3058;\r\n            padding: 0;\r\n            overflow: hidden;\r\n            display: -webkit-box;\r\n            -webkit-line-clamp: 2;\r\n            line-clamp: 2;\r\n            -webkit-box-orient: vertical;\r\n        }\r\n\r\n        .link {\r\n            margin-top: 10px;\r\n            display: flex;\r\n\r\n            span {\r\n                display: inline-block;\r\n                color: #000000;\r\n                font-size: 16px;\r\n                margin-left: 10px;\r\n                width: 60px;\r\n            }\r\n\r\n            ul {\r\n                list-style: none;\r\n                margin: 0;\r\n                padding: 0;\r\n\r\n                a, a:hover {\r\n                    font-weight: 600 !important;\r\n                }\r\n            }\r\n        }\r\n\r\n        .keywords {\r\n            margin-top: 10px;\r\n\r\n            span {\r\n                display: inline-block;\r\n                color: #000000;\r\n                font-size: 16px;\r\n                margin-left: 10px;\r\n                width: 60px;\r\n            }\r\n\r\n            ul {\r\n                list-style: none;\r\n                padding: 0;\r\n                margin: 0;\r\n                display: inline;\r\n\r\n                li {\r\n                    background-color: #EBF3FF;\r\n                    color: #000000;\r\n                    border-radius: 50px;\r\n                    font-size: 14px;\r\n                    padding: 5px 15px;\r\n                    margin: 0 0 0 8px;\r\n                    display: inline-block;\r\n                    transition: 0.3s;\r\n\r\n                    span {\r\n                        padding-left: 5px;\r\n                        color: color-mix(in srgb, var(--default-color), transparent 60%);\r\n                        font-size: 14px;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        .categories {\r\n            margin-top: 10px;\r\n\r\n            span {\r\n                display: inline-block;\r\n                color: #000000;\r\n                font-size: 16px;\r\n                margin-left: 10px;\r\n                width: 60px;\r\n            }\r\n\r\n            ul {\r\n                list-style: none;\r\n                padding: 0;\r\n                margin: 0;\r\n                display: inline;\r\n\r\n                li {\r\n                    background-color: #FFECC2;\r\n                    color: #000000;\r\n                    border-radius: 50px;\r\n                    font-size: 14px;\r\n                    padding: 5px 15px;\r\n                    margin: 0 0 0 8px;\r\n                    display: inline-block;\r\n                    transition: 0.3s;\r\n\r\n                    span {\r\n                        padding-left: 5px;\r\n                        color: color-mix(in srgb, var(--default-color), transparent 60%);\r\n                        font-size: 14px;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"results-collapse": `NHDB7139cbMqf04GQoUs`,
	"card-container": `QXwQI7mwcty7XCJrxRtc`,
	"description-container": `NKivG21Efn5Gl2JO88wo`,
	"description": `gDgJkq_46q5sJ0kSVrdW`,
	"text-clamp-3": `LyyBsSJAqafj8Cg8C2_v`,
	"read-more": `PU2p8D14G3lgQWXrHhak`,
	"card-header": `N7KLsHljLdXNCDe5MgMc`,
	"link": `RFiG3euW7aU7RecxDyx7`,
	"keywords": `wL4qPyu95KCXPhN_jubU`,
	"categories": `_1o1FB3AeSfBrXFAcMVeb`
};
export default ___CSS_LOADER_EXPORT___;
